import { Reducer } from 'redux'
import { FETCH_EQUIPMENT_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/equipment'
import { CREATE_TRAILER_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/trailer'
import { CREATE_TRUCK_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/truck'
import { ICreateTrailerSuccessAction } from 'apps/fleet-planner/utils/reducers/trailer'
import { ICreateTruckSuccessAction } from 'apps/fleet-planner/utils/reducers/truck'
import {
  IEquipmentState,
  EquipmentAction,
  ISuccessAction,
} from 'apps/fleet-planner/utils/types/equipment'

const { CREATE_TRAILER_SUCCESS } = CREATE_TRAILER_ACTION_TYPES
const { CREATE_TRUCK_SUCCESS } = CREATE_TRUCK_ACTION_TYPES

const {
  FETCH_EQUIPMENT_FAILURE,
  FETCH_EQUIPMENT_REQUEST,
  FETCH_EQUIPMENT_SUCCESS,
} = FETCH_EQUIPMENT_ACTION_TYPES

const defaultState: IEquipmentState = {
  fetching: false,
  trucks: [],
  trailers: [],
}

export const equipmentReducer: Reducer<IEquipmentState, EquipmentAction> = (
  state = defaultState,
  action
): IEquipmentState => {
  switch (action.type) {
    case FETCH_EQUIPMENT_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case CREATE_TRAILER_SUCCESS: {
      const {
        payload: { trailer },
      } = action as ICreateTrailerSuccessAction
      const filteredTrailers = state.trailers.filter(t => t.id !== trailer.id)
      return {
        ...state,
        trailers: [...filteredTrailers, trailer],
      }
    }
    case CREATE_TRUCK_SUCCESS: {
      const {
        payload: { truck },
      } = action as ICreateTruckSuccessAction
      const filteredTrucks = state.trucks.filter(t => t.id !== truck.id)
      return {
        ...state,
        trucks: [...filteredTrucks, truck],
      }
    }
    case FETCH_EQUIPMENT_SUCCESS: {
      const {
        payload: { trailers, trucks },
      } = action as ISuccessAction
      return {
        ...state,
        trucks,
        trailers,
        fetching: false,
      }
    }
    case FETCH_EQUIPMENT_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    }
    default:
      return state
  }
}
